import { useMemo } from "react";
import client from "libs/client";
import type { ProgramGameSelectOption } from "../types";

/**
 * National league options for the program game modal, scoped to the home club's country.
 * Only fetched when the game is national and a home club is selected.
 */
export function useProgramGameNationalLeagueOptions(
	isOpen: boolean,
	isNational: boolean,
	homeClubId: number | null,
	awayClubId: number | null,
): { nationalLeagueOptions: ProgramGameSelectOption[]; nationalLeaguesLoading: boolean } {
	const enabled = isOpen && isNational && homeClubId !== null && !Number.isNaN(homeClubId);

	const { data, isLoading } = client.getDiscoverGamesProgramGameNationalLeagues.useQuery(
		{
			homeClubId: homeClubId ?? 0,
			awayClubId: awayClubId !== null && !Number.isNaN(awayClubId) ? awayClubId : undefined,
		},
		{ enabled },
	);

	const nationalLeagueOptions = useMemo(
		() => (data?.data ?? []).map((option) => ({ value: option.value, label: option.label })),
		[data],
	);

	return { nationalLeagueOptions, nationalLeaguesLoading: enabled && isLoading };
}
